import { useBreakpointValue } from "@gluestack-ui/themed";
import { zodResolver } from "@hookform/resolvers/zod";
import { Permission } from "@repo/core/constants/permissions";
import { useUserPermissions } from "@repo/core/hooks/useUserPermissions";
import useAuthStore from "@repo/core/stores/auth";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { AuthorizationModalProps } from "./types";

const formSchema = z.object({
  strUsuario: z.string().min(4),
  strSenha: z.string().min(4)
});

export type FormDataType = z.infer<typeof formSchema>;
export const useAuthorizationModalController = ({
  onConfirm
}: Partial<AuthorizationModalProps>) => {
  const { user } = useAuthStore();
  const { hasPermission } = useUserPermissions();

  const isMobile = useBreakpointValue({ base: true, md: false });

  const {
    control,
    handleSubmit,
    setValue,
    formState: { isValid }
  } = useForm<FormDataType>({
    resolver: zodResolver(formSchema)
  });

  const onSubmit = handleSubmit((data) => {
    onConfirm?.(data);
  });

  useEffect(() => {
    if (
      hasPermission([Permission.CRT_WEBAPI_TERMINAL]) &&
      hasPermission([Permission.CRT_WEBAPI_CLIENTE])
    ) {
      setValue("strUsuario", user?.username || "");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return { control, isMobile, onSubmit, isValid };
};
